import { useRef, useCallback, useEffect } from 'react';
import { fabric } from 'fabric';
import { MODESTATE } from '@view/page_v3/AiEdit/CONST'

// 删除icon
let deleteIcon = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";
let deleteImg = document.createElement('img');
deleteImg.src = deleteIcon;

function renderIcon(icon) {
    return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
        var size = this.cornerSize;
        ctx.save();
        ctx.translate(left, top);
        ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        ctx.drawImage(icon, -size / 2, -size / 2, size, size);
        ctx.restore();
    }
}

export function useDrawRect(fabricInstanceRef, drawingRef, getIsDraw, modeStateRef) {
    const rectRef = useRef(null);

    const deleteIconFun = (obj) => {
        obj.controls.deleteControl = new fabric.Control({
            x: 0.5,
            y: -0.5,
            offsetY: -12,
            offsetX: 12,
            cursorStyle: 'pointer',
            render: renderIcon(deleteImg),
            cornerSize: 20,
            mouseUpHandler: function (eventData, transform) {
                const target = transform.target;
                if (target) {
                    props.getIsDraw(target);
                    fabricInstanceRef.current.remove(target);
                    fabricInstanceRef.current.renderAll();
                }
            }
        })
    }

    const startRect = useCallback((event) => {
        const canvas = fabricInstanceRef.current;
        if (!canvas || !drawingRef.current) return;

        const activeObject = canvas.getActiveObject();
        if (activeObject) return;

        const { offsetX, offsetY } = event.e;
        const zoom = canvas.getZoom();
        const canvasOffsetX = canvas.viewportTransform[4];
        const canvasOffsetY = canvas.viewportTransform[5];
        const x = (offsetX - canvasOffsetX) / zoom;
        const y = (offsetY - canvasOffsetY) / zoom;

        const rect = new fabric.Rect({
            left: x,
            top: y,
            width: 0,
            height: 0,
            fill: modeStateRef.current == MODESTATE.ERASER? ' ': 'rgba(30, 144, 255, 0.8)',
            strokeWidth: 2,
            lockRotation: true,
            cornerSize: 8,
            selectable: false,
            evented: false,
            globalCompositeOperation: modeStateRef.current == MODESTATE.ERASER? 'destination-out' : 'source-over'
        });

        rect.setControlsVisibility({ mtr: false }); // 关闭旋转控制点
        // if (typeof deleteIconFun === 'function') {
        //     deleteIconFun(rect); // 添加删除按钮
        // }

        rect.startX = x;
        rect.startY = y;

        canvas.add(rect);
        rectRef.current = rect;
    }, [fabricInstanceRef, drawingRef, deleteIconFun]);

    const moveRect = useCallback((event) => {
        const canvas = fabricInstanceRef.current;
        const rect = rectRef.current;
        if (!canvas || !rect || !drawingRef.current) return;

        const { offsetX, offsetY } = event.e;
        const zoom = canvas.getZoom();
        const canvasOffsetX = canvas.viewportTransform[4];
        const canvasOffsetY = canvas.viewportTransform[5];
        const x = (offsetX - canvasOffsetX) / zoom;
        const y = (offsetY - canvasOffsetY) / zoom;

        const width = Math.abs(x - rect.startX);
        const height = Math.abs(y - rect.startY);

        rect.set({
            left: x < rect.startX ? x : rect.startX,
            top: y < rect.startY ? y : rect.startY,
            width: width,
            height: height,
        });

        canvas.renderAll();
    }, [fabricInstanceRef, drawingRef]);

    const endRect = useCallback(() => {
        const canvas = fabricInstanceRef.current;
        if (!canvas || !rectRef.current) return;
 
        rectRef.current.setCoords();
        rectRef.current = null;            
        const rectList = canvas.getObjects().filter(obj => obj.type === 'rect');
        if (typeof getIsDraw === 'function') {
            getIsDraw(rectList);
        }
    }, [fabricInstanceRef, getIsDraw]);

    const handleMouseOut = () => {
        if (drawingRef.current) {
            endRect();
        }
    };

    const cancelRectDrawing = () => {
        const rect = rectRef.current;
        if (rect) {
            fabricInstanceRef.current.remove(rect);
        }
        drawingRef.current = false;
        rectRef.current = null;
    };


    useEffect(() => {
        window.addEventListener('mouseout', handleMouseOut);
        return () => {
            window.removeEventListener('mouseout', handleMouseOut);
        };
    }, []);

    return {
        startRect,
        moveRect,
        endRect,
    };
}
